import React from 'react';
import classNames from "classnames";
import PropTypes from "prop-types";

class RadioBox extends React.Component {

    static propTypes = {
        name: PropTypes.any,
        value: PropTypes.any,
        disabled: PropTypes.bool,
        style: PropTypes.any,
        className: PropTypes.any,
        error: PropTypes.any,
        checked: PropTypes.bool,
        label: PropTypes.any,
        required: PropTypes.bool,
        saveChanges: PropTypes.func,
    }

    onChange = (e) => {
        if (this.props.disabled) return;
        const v = this.props.value;
        if (this.props.saveChanges) {
            this.props.saveChanges(this.props.name, v);
        }
    }

    render() {
        const checked = this.props.checked || false;
        return <div className={classNames("radio", {disabled: this.props.disabled}, this.props.className)} style={this.props.style}>
            <label className={classNames({"is-invalid": this.props.error})}>
                <div className="p-radiobutton p-component">
                    <div className="p-hidden-accessible">
                        <input type="radio"
                               name={this.props.name}
                               checked={checked}
                               value={this.props.value}
                               disabled={this.props.disabled || false}
                               onChange={this.onChange}
                        />
                    </div>
                    <div className={classNames("p-radiobutton-box p-component",{"p-highlight": checked})}><span
                        className={classNames("p-radiobutton-icon p-c", {"pi pi-circle-on": checked})} /></div>
                </div>
                {this.props.label} {this.props.required && <span className="invalid-feedback">*</span>}
            </label>
            {this.props.error && <div className="invalid-feedback">{this.props.error}</div>}
        </div>
    }
}

export default RadioBox;